<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-row">
        <div class="list-header-title-div">服务费配置记录</div>
        <div class="page-action-btns flex">
          <button class="common-bg-button" @click="search">查 询</button>
          <button class="common-bg-button" @click="toggleFilters">高级筛选</button>
          <button class="common-bg-button" @click="exportList">导 出</button>
        </div>
      </div>

      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">活动订单编号</p>
              <el-input clearable v-model="queryInfo.activityOrderNo" size="small" placeholder="请输入活动订单编号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">用户账号/手机号</p>
              <el-input clearable v-model="queryInfo.mobile" size="small" placeholder="请输入用户账号/手机号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">支付类型</p>
              <el-select v-model="queryInfo.giftType" size="small" clearable style="width: 100%" placeholder="请选择支付类型">
                <el-option label="售后赠送" value="AFTER_SALE_GIFT" />
                <el-option label="活动赠送" value="ACTIVITY_GIFT" />
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="margin-top-10">
            <el-col :span="12">
              <p class="margin-bottom-5 font-14">配置创建时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="createTime" @change="pickCreateTime" range-separator="-" start-placeholder="开始时间"
                end-placeholder="结束时间" style="width: 100%">
              </el-date-picker>
            </el-col>
          </el-row>
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="reset">重 置</button>
          <button class="common-bg-button" @click="search">搜 索</button>
        </div>
      </div>

      <el-table :data="giftList" size="small" border style="width: 100%">
        <el-table-column prop="activityOrderNo" label="活动订单编号" min-width="160">
          <template slot-scope="{ row }">{{ row.activityOrderNo || '-' }}</template>
        </el-table-column>
        <el-table-column prop="userNo" label="用户账号" min-width="100">
          <template slot-scope="{ row }">{{ row.userNo || '-' }}</template>
        </el-table-column>
        <el-table-column prop="userName" label="用户姓名" min-width="100">
          <template slot-scope="{ row }">{{ row.userName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width="120">
          <template slot-scope="{ row }">
            <span v-if="row.mobile">{{ row.mobile }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称" min-width="180">
          <template slot-scope="{ row }">{{ row.activityName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="giftMonths" label="服务费配置周期" min-width="130" align="center">
          <template slot-scope="{ row }">{{ row.giftMonths ? row.giftMonths + '个月' : '-' }}</template>
        </el-table-column>
        <el-table-column prop="giftAmount" label="服务费配置金额" min-width="130" align="center">
          <template slot-scope="{ row }">{{ row.giftAmount ? row.giftAmount + '元' : '-' }}</template>
        </el-table-column>
        <el-table-column prop="giftType" label="支付方式" min-width="100">
          <template slot-scope="{ row }">{{ getGiftTypeText(row.giftType) }}</template>
        </el-table-column>
        <el-table-column prop="alipayResult" label="赠送结果" min-width="100">
          <template slot-scope="{ row }">
            <span :style="{ color: getAlipayResultColor(row.alipayResult) }">
              {{ getAlipayResultText(row.alipayResult) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="alipayMsg" label="赠送信息" min-width="200">
          <template slot-scope="{ row }">{{ row.alipayMsg || '--' }}</template>
        </el-table-column>
        <el-table-column prop="lastModifiedByName" label="操作人" min-width="100">
          <template slot-scope="{ row }">{{ row.lastModifiedByName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createdWhen" label="配置创建时间" min-width="170">
          <template slot-scope="{ row }">{{ row.createdWhen || '-' }}</template>
        </el-table-column>
      </el-table>

      <div class="list-pagination">
        <el-pagination background layout="total, prev, pager, next, sizes, jumper" :current-page="pagination.current"
          :page-size="pagination.pageSize" :page-sizes="[10, 20, 50, 100]" :total="pagination.total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GiftRecordList",
  data() {
    return {
      queryInfo: {
        activityOrderNo: "",
        mobile: "",
        userNo: "",
        giftType: "",
        startCreateWhen: "",
        endCreateWhen: "",
        pageNum: 1,
        pageSize: 10,
      },
      createTime: [],
      showMultiQuerys: false,
      giftList: [],
      pagination: { current: 1, pageSize: 10, total: 0 },
      breadCrumb: [
        { name: "营销活动" },
        { name: "安心包598活动" },
        { name: "服务费配置记录" },
      ],
    };
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
  methods: {
    getGiftTypeText(giftType) {
      const map = {
        AFTER_SALE_GIFT: '售后赠送',
        ACTIVITY_GIFT: '活动赠送',
        MANUAL_GIFT: '手动赠送',
      };
      return map[giftType] || giftType || '-';
    },
    getAlipayResultText(result) {
      const map = { SUCCESS: '成功', FAIL: '失败', SKIP: '跳过' };
      return map[result] || result || '--';
    },
    getAlipayResultColor(result) {
      const map = { SUCCESS: '#67C23A', FAIL: '#F56C6C', SKIP: '#909399' };
      return map[result] || '#606266';
    },
    getListData(pagination, reload = false) {
      const _ = this;
      _.$U.showLoading(_);
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 1;
      } else {
        _.pagination.current = pagination.current;
        _.queryInfo.pageNum = pagination.current;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      const params = {
        ..._.queryInfo,
        corpNo: _.$store.state.corpNo,
        pageNum: (_.queryInfo.pageNum || 1) - 1,
        pageSize: _.queryInfo.pageSize || 10,
      };
      Object.keys(params).forEach((k) => params[k] === "" && delete params[k]);
      _.$H
        .post(_, _.$A.giftTraffic.recordPage, params)
        .then((res) => {
          const payload = res?.data?.data ?? res?.data ?? {};
          _.giftList = payload?.content ?? payload?.list ?? payload?.records ?? [];
          _.pagination.total = payload?.totalElements ?? payload?.total ?? 0;
        })
        .catch(() => {
          _.giftList = [];
          _.pagination.total = 0;
        })
        .finally(() => {
          _.$U.hideLoading(_);
        });
    },
    pickCreateTime(time) {
      this.queryInfo.startCreateWhen = time && time[0] ? time[0] : "";
      this.queryInfo.endCreateWhen = time && time[1] ? time[1] : "";
    },
    toggleFilters() {
      this.showMultiQuerys = !this.showMultiQuerys;
    },
    search() {
      this.getListData(this.pagination, true);
    },
    reset() {
      this.queryInfo = {
        activityOrderNo: "",
        mobile: "",
        userNo: "",
        giftType: "",
        startCreateWhen: "",
        endCreateWhen: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.createTime = [];
      this.getListData(this.pagination, true);
    },
    handleCurrentChange(page) {
      this.pagination.current = page;
      this.getListData(this.pagination, false);
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.current = 1;
      this.getListData(this.pagination, true);
    },
    exportList() {
      const _ = this;
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6771";
      } else {
        urls = "http://192.168.8.174:7997";
      }

      _.$U.showLoading(_);
      const exportQueryInfo = {
        ..._.queryInfo,
        corpNo: _.$store.state.corpNo,
        pageNum: undefined,
        pageSize: undefined,
      };
      Object.keys(exportQueryInfo).forEach((k) => exportQueryInfo[k] === "" && delete exportQueryInfo[k]);

      _.$H
        .post(_, _.$A.giftTraffic.exportGiftRecord, exportQueryInfo)
        .then((res) => {
          if (res.data && res.data.data) {
            const data = res.data.data;
            if (data.base64 || data.fileName) {
              _.$U.saveExcelFile(data);
            }
            if (data.filePath) {
              let downUrl = data.filePath;
              if (!downUrl.startsWith("http")) {
                downUrl = urls + downUrl;
              }
              window.open(downUrl, "_blank");
            }
            _.$U?.success ? _.$U.success("导出成功") : _.$message.success("导出成功");
          } else {
            _.$U?.error
              ? _.$U.error(res.data?.msg || res.data?.message || "导出失败：未获取到文件信息")
              : _.$message.error(res.data?.msg || res.data?.message || "导出失败：未获取到文件信息");
          }
        })
        .catch((err) => {
          _.$U?.error
            ? _.$U.error(
                err?.response?.data?.msg || err?.response?.data?.message || err?.message || "导出失败"
              )
            : _.$message.error(
                err?.response?.data?.msg || err?.response?.data?.message || err?.message || "导出失败"
              );
        })
        .finally(() => {
          _.$U.hideLoading(_);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.list-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-action-btns {
  gap: 12px;
}

.margin-tb-10 {
  margin: 10px 0;
}

.multi-query-div {
  padding: 16px;
  background: #f6f8fb;
  border-radius: 6px;
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}
</style>
